import {
  Box,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { useRoleContext } from "hooks";

import { RoutePointSelect } from "./RoutePointSelect";

interface Props {
  notes: string;
  onNotesUpdate: (newValue: string) => void;
  loading: boolean;
  error: string | null;
  etaTimestamp: string;
  onEtaTimestampUpdate: (newValue: string) => void;
  shipment: CondensedShipment;
  routePointId: number | undefined;
  setRoutePointId: (newValue: number | undefined) => void;
}

export function AddRoutePointETAModalContent(props: Props) {
  const {
    loading,
    notes,
    onNotesUpdate,
    error,
    etaTimestamp,
    onEtaTimestampUpdate,
    shipment,
    routePointId,
    setRoutePointId,
  } = props;
  const { role } = useRoleContext();

  if (loading || !role) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6" sx={{ mt: ".5rem" }}>
        Please enter a route point and an ETA
      </Typography>
      <RoutePointSelect
        shipment={shipment}
        routePointId={routePointId}
        setRoutePointId={setRoutePointId}
      />
      <TextField
        id="datetime-local"
        label="ETA"
        type="datetime-local"
        value={etaTimestamp}
        onChange={(e) => onEtaTimestampUpdate(e.target.value)}
      />
      <Box mb="2rem">
        <TextField
          id="eta-notes"
          variant="outlined"
          onChange={(e) => onNotesUpdate(e.target.value)}
          value={notes}
          sx={{ width: "100%" }}
          multiline
          maxRows={20}
          minRows={1}
          placeholder="Example: ETA Depending on road conditions"
          label="Optional additional notes"
          autoFocus
        />
        <Typography variant="body2" color="text.secondary">
          Notes and delivery time will be shared with the{" "}
          {role.type === "CARRIER" ? "shipper" : "carrier"}.
        </Typography>
      </Box>
      {error != null && !loading && (
        <Typography color="red" align="center">
          {error}
        </Typography>
      )}
    </Stack>
  );
}
